import React from 'react';
import { Form, FormProps } from 'react-final-form';

import { createStorageDecorator } from '@blocks/_common/decorators/storageDecorator';
import {
  changeLoginAbility,
  clearSubmitError,
  removeLogin,
  setLogin,
  toggleGdpr,
} from '@blocks/_common/mutators';
import {
  applyDeadline,
  applyLogin,
  applyTitle,
  correctTime,
  removeTitle,
  removeWriter,
  requestWriter,
  setRecommendedDeadline,
  togglePolicy,
} from '@blocks/_common/mutators/order';

import { subscription } from './constants';
import {
  createAnalyticsDecorator,
  createDataBoxDecorator,
  createFocusDecorator,
  createPoliciesDecorator,
  createTitleDecorator,
  createWriterDecorator,
} from './decorators';
import {
  applyPages,
  applyPaperSizeType,
  applyPaperType,
  applyWords,
  decPages,
  decWords,
  incPages,
  incWords,
} from './mutators';

const FormBase: React.FC<FormProps> = ({ decorators = [], ...props }) => {
  return (
    <Form
      decorators={[
        createStorageDecorator,
        createWriterDecorator,
        createAnalyticsDecorator,
        createDataBoxDecorator,
        createPoliciesDecorator,
        createFocusDecorator,
        createTitleDecorator,
      ].concat(decorators)}
      mutators={{
        correctTime,
        decPages,
        incPages,
        decWords,
        incWords,
        toggleGdpr,
        setRecommendedDeadline,
        clearSubmitError,
        removeWriter,
        requestWriter,
        setLogin,
        removeLogin,
        applyPaperType,
        applyPages,
        applyWords,
        applyPaperSizeType,
        applyDeadline,
        applyTitle,
        removeTitle,
        togglePolicy,
        changeLoginAbility,
        applyLogin,
      }}
      subscription={subscription}
      {...props}
    />
  );
};

export default FormBase;
